import { atom } from 'jotai';

/**
 * An optional step Remove patient runs before the session unlink, for an
 * entry point that owns more than the link: the transcript speaker pane
 * clears the clicked speaker first. Set together with UnlinkedSessionIdAtom
 * and cleared with it; it runs only for the session it was set for, so a
 * modal opened later from the header never runs a stale step. A rejection
 * skips the unlink.
 */
export const unlinkSessionBeforeConfirmAtom = atom<{
  sessionId: string;
  run: () => Promise<void>;
} | null>(null);

/**
 * True while a Remove patient confirm runs its step and the unlink. Shared,
 * not per instance: the session page and an embedded session artifact can
 * both mount the modal, and one confirm must block the other's confirm.
 */
export const unlinkSessionConfirmInFlightAtom = atom(false);
